import { useMemo } from "react";
import styled from "styled-components";

type Props = {
  children: JSX.Element;
  title?: string;
  onClose?: () => void;
  width?: number;
  maxHeight?: number;
  noScroll?: boolean;
};

const Modal = (props: Props) => {
  const width = useMemo(() => {
    return `${props.width || 320}px`;
  }, [props.width]);

  const maxHeight = useMemo(() => {
    return `${props.maxHeight || 500}px`;
  }, [props.maxHeight]);

  const modalBody = useMemo(() => {
    return (
      <div className="modal-body" style={{ width, maxHeight, overflowY: props.noScroll ? "hidden" : "scroll" }}>
        {props.title ? <div className="modal-title">{props.title}</div> : <></>}
        {props.children}
      </div>
    );
  }, [maxHeight, props.children, props.noScroll, props.title, width]);

  const component = useMemo(
    () => (
      <ModalStyle>
        <div className="modal-wrapper">
          <div
            className="modal-overlay"
            onClick={() => {
              if (props.onClose) {
                props.onClose();
              }
            }}
          ></div>
          {modalBody}
        </div>
      </ModalStyle>
    ),
    [modalBody, props],
  );

  return component;
};

export default Modal;

const ModalStyle = styled.div`
  .modal-wrapper {
    .modal-overlay {
      position: fixed;
      z-index: 1100;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(128, 123, 123, 0.7);
    }
    .modal-body {
      z-index: 1101;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: white;
      padding: 16px 16px 16px 16px;
      box-shadow: 10px 10px 0 0 black;
      color: black;
      .modal-title {
        color: black;
        width: 280px;
        text-align: center;
        margin: 0 auto 10px auto;
        font-size: 16px;
        font-weight: bold;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`;
